import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ChatWidget from "@/components/ChatWidget";
import { LEGAL } from "@/lib/brand";

function LegalMarquee() {
  return (
    <div className="bg-ape-red text-black overflow-hidden py-1.5 relative z-20" data-testid="legal-banner">
      <div className="marquee-track font-mono2 text-[11px] sm:text-xs font-bold tracking-[0.25em]">
        {Array.from({ length: 8 }).map((_, i) => (
          <span key={i} className="mx-6 inline-flex items-center gap-3">
            {LEGAL} <span className="opacity-60">///</span>
          </span>
        ))}
      </div>
    </div>
  );
}

export default function Layout() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-ape-bg text-white relative">
      <LegalMarquee />
      <Navbar />
      <main className="flex-1 relative z-10">
        <Outlet />
      </main>
      <Footer />
      <ChatWidget />
    </div>
  );
}
